/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { getSubMenusFromDepartment } from '../../services/ApiCalls';

const ShowSubmenus = (props) => {
  const { department, handleClick, setChangeId } = props;
  const { id_depto, depto } = department;
  const [subMenus, setSubMenus] = useState([]);

  useEffect(() => {
    async function apiCall() {
      const response = await getSubMenusFromDepartment(id_depto);
      setSubMenus(response);
    }
    apiCall();
  });

  return (
    <ul>
      <li
        className="departments-sub"
        onClick={() => {
          setChangeId('close-slide');
          setTimeout(() => {
            handleClick();
            setChangeId('slide');
          }, 500);
        }}
      >
        {depto}
        <button
          type="button"
          className="back-button"
          onClick={() => {
            setChangeId('close-slide');
            setTimeout(() => {
              handleClick();
              setChangeId('slide');
            }, 500);
          }}
        >
          <ArrowBackIosNewIcon fontSize="small" />
          Voltar
        </button>
      </li>
      { subMenus.map((sub) => (
        <a href={`https://www.alobebe.com.br/${sub.tx_url},c,${sub.id_depto}`}>
          <li className="sub-menu" key={sub.id_depto}>

            <ArrowForwardIosIcon className="next-icon" fontSize="10px" style={{ marginRight: '20px' }} />
            { sub.depto }
          </li>
        </a>
      ))}
    </ul>
  );
};

ShowSubmenus.propTypes = {
  department: PropTypes.shape({
    id_depto: PropTypes.number,
    depto: PropTypes.string,
  }),
  handleClick: PropTypes.func,
  setChangeId: PropTypes.string,
}.isRequired;

export default ShowSubmenus;
